module.exports = __webpack_public_path__ + "img/cognitiveIco.e4652d7b.svg";